/**
 * Variables Globales para Movistar Prosegur
 */

export const Globals = {
    /*Id Tag D1C*/
       idTagD1C: "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ac2da4161ee4b51c787d932128d01dd74e062729a303b07f9061786d352024d95fdab00720088edadbfcc0692f56e83d3056a8963b1d5d8dac96ca134293ed27ddaa2bebc911b97b6f3fc8e75724cd6d6",
    DelioOneClick:{
        init:"https://t.womtp.com/slider/c/delio-lm/dfi/init.js"
    }
}